import { useTranslation } from "react-i18next";
import { Layout } from "src/components/Layout";

export function ComingSoon() {
  const { t } = useTranslation();

  return (
    <div className="w-full h-screen px-6 overflow-y-auto pt-4" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)" }}>
      <div className="sticky top-0 z-10 py-4 pb-4" style={{ backgroundColor: "var(--bg-base)" }}>
        <h3 className="col-span-2 mt-10 mb-2 text-4xl font-semibold tracking-wide text-center">
          {t('coming_soon.title', { defaultValue: 'Coming Soon' })}
        </h3>

        <p className="text-center text-white/70 text-lg max-w-xl mx-auto">
          {t('coming_soon.subtitle', {
            defaultValue: 'We’re working hard to bring you this feature. Stay tuned!',
          })}
        </p>

        <div className="mx-96 mt-4 h-1 bg-gradient-to-r from-transparent via-[var(--color-primary)] to-transparent"></div>
      </div>
    </div>
  );
}